import React from 'react';
import MRB_2 from '../gallaries/MRB_2.JPG';
import MRB_3 from '../gallaries/MRB_3.JPG';
import MRB_80 from '../gallaries/MRB_80.JPG';
import MRB_88 from '../gallaries/MRB_88.JPG';
import MRB_41 from '../gallaries/MRB_41.JPG';
import MRB_17 from '../gallaries/MRB_17.JPG';

const Gallery = () => {
  const galleryImages = [
    MRB_2,
    MRB_3,
    MRB_80,
    MRB_88,
    MRB_41,
    MRB_17
  ];

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <h2 className="section-title">Our Impact</h2>
        <div className="gallery-container">
          {galleryImages.map((image, index) => (
            <div key={index} className="gallery-item">
              <img src={image} alt={`Gallery ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;